import { React, useState, useEffect, useContext } from 'react';
import UserContext from '../../components/User_Context.js';
import * as menu from "../../assets/menus/menu.js";
import * as api from "../../api/apiConnector.js";
import { useParams } from 'react-router-dom';
import standardPic from '../../assets/images/avatar/pic7.jpg';
import googleLogo from '../../assets/images/logo/google.png';
import Loader from '../../components/ui/loader.js';
import localLogo from '../../assets/images/logo/local.svg';
import oauthLogo from '../../assets/images/logo/oauth.png';
import casLogo from '../../assets/images/logo/centralized-connection.svg';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Choices from '../../components/Choices.js';

import * as breadcrumb from "../../components/ui/breadcrumb.js";
import { useTranslation } from 'react-i18next';
import { userGroupsLabels } from '../label/user_groups_labels.js';
import { quickselect } from 'd3';


function Users_Profile_Screen(params) {
    const { type = "user" } = params;

    const { id } = useParams();
    const { currentUser } = useContext(UserContext);
    const [data, setData] = useState(null);
    const [groupsVoc, setGroupsVoc] = useState(null);
    const [linkedGroupsDb, setLinkedGroupsDb] = useState(null)
    const [membersVoc, setMembersVoc] = useState(null);
    const [linkedMembersDB, setLinkedMembersDB] = useState(null);
    
    // Lazy loading states for member search
    const [memberSearchTerm, setMemberSearchTerm] = useState('');
    const [memberSearchResults, setMemberSearchResults] = useState([]);
    const [isSearchingMembers, setIsSearchingMembers] = useState(false);
    const [showMemberSearchResults, setShowMemberSearchResults] = useState(false);
    const [availableGroups, setAvailableGroups] = useState([]);
    const [selectedGroupForPermissions, setSelectedGroupForPermissions] = useState(null);
    const [readPermission, setReadPermission] = useState(false);
    const [writePermission, setWritePermission] = useState(false);
    const [listPermission, setListPermission] = useState(false);
    const [deletePermission, setDeletePermission] = useState(false);
    const [savingPermissions, setSavingPermissions] = useState(false);
    const [userGroupPermissions, setUserGroupPermissions] = useState([]);

    // Rights Tree states
    const [rightsTree, setRightsTree] = useState([]);
    const [selectedRightsNode, setSelectedRightsNode] = useState("");
    const [selectedRightsNodeObject, setSelectedRightsNodeObject] = useState(null);
    const [userRightsPermissions, setUserRightsPermissions] = useState([]);


    const { t } = useTranslation();

    // Initialize i18n labels from centralized file
    const i18n = menu.getI18n();
    i18n.addResourceBundle('it', 'labels', userGroupsLabels.it, true, true);
    i18n.addResourceBundle('en', 'labels', userGroupsLabels.en, true, true);

    // Transform rights tree data for Choices component
    const transformRightsTreeData = (treeNodes, level = 0) => {
        let result = [];

        treeNodes.forEach(node => {
            const indent = '  '.repeat(level);
            result.push({
                Code: node.Id,
                Name: `${indent}${node.Name}${node.Description ? ` - ${node.Description}` : ''}`,
                Level: node.Level,
                OriginalNode: node
            });

            if (node.Children && node.Children.length > 0) {
                result = result.concat(transformRightsTreeData(node.Children, level + 1));
            }
        });

        return result;
    };

    // Load rights tree
    const loadRightsTree = async () => {
        try {
            const rightsTreeResult = await api.sendMessage("security/rightsTree/getTree", {
                user: currentUser(),
                body: {}
            });

            if (rightsTreeResult?.success && rightsTreeResult?.rightsTree) {
                const transformedTree = transformRightsTreeData(rightsTreeResult.rightsTree);
                setRightsTree(transformedTree);
            }
        } catch (error) {
            console.error("Error loading rights tree:", error);
        }
    };

    useEffect(() => {
        (async () => {



            setBreadCrumb();
            let _data;
            menu.write({ user: currentUser() });
            let result;

            // Load rights tree for all types
            await loadRightsTree();
            //if im in group mode retrive the group otherwise retrive the user
            if (type === "group") {
                result = await getGroup(id);
                if (result.success) {
                    if (result?.group) {
                        _data = result?.group;
                        setData({ group: _data });

                        // Don't load all users anymore - we'll use lazy loading
                        setMembersVoc(result.smallUserDataLink ?? []); // Initialize as empty array

                        var linked_members = (result?.linked_members) ? result?.linked_members : [];
                        
                        // Create updated links with user data from smallUserDataLink
                        const updatedLinks = [];
                        
                        linked_members.forEach(member => {
                            // Find corresponding user data in smallUserDataLink
                            const selectedUser = result.smallUserDataLink?.find(user => 
                                user.Id === member.Back_End_User_Id
                            );
                            
                            const newLink = {
                                Back_End_User_Id: member.Back_End_User_Id,
                                Back_End_Member_Of_Group_Id: id,
                                // Include user name data if available from search results
                                User_Name: selectedUser?.Name || null,
                                User_LastName: selectedUser?.LastName || null
                            };
                            
                            updatedLinks.push(newLink);
                        });
                        
                        setLinkedMembersDB(updatedLinks);
                    }
                    else {
                        withReactContent(Swal).fire({
                            title: t('itemNotFound', { ns: 'labels' }),
                            icon: "error",
                            text: t('itemNotFoundMessage', { ns: 'labels' }),
                            showConfirmButton: true,
                            showCancelButton: false,
                            confirmButtonText: t('goBack', { ns: 'labels' }),
                            allowOutsideClick: false
                        }).then(async (result) => {
                            if (result.isConfirmed) {
                                window.location.href = `/admin/users_and_groups`;
                            }
                        });
                    }
                } else {
                    withReactContent(Swal).fire({
                        title: t('error', { ns: 'labels' }),
                        icon: "error",
                        text: t(result.message.toLowerCase(), { ns: 'labels' }),
                        showConfirmButton: true,
                        allowOutsideClick: false
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            window.location.href = `/admin/users_and_groups`;
                        }
                    });
                }
            } else {
                result = await getUser(id);
                if (result.success) {
                    if (result?.user) {
                        _data = result?.user;
                        setData({ user: _data });
                    }
                    else {
                        withReactContent(Swal).fire({
                            title: t('itemNotFound', { ns: 'labels' }),
                            icon: "error",
                            text: t('itemNotFoundMessage', { ns: 'labels' }),
                            showConfirmButton: true,
                            showCancelButton: false,
                            confirmButtonText: t('goBack', { ns: 'labels' }),
                            allowOutsideClick: false
                        }).then(async (result) => {
                            if (result.isConfirmed) {
                                window.location.href = `/admin/users_and_groups`;
                            }
                        });
                    }
                } else {
                    withReactContent(Swal).fire({
                        title: t('error', { ns: 'labels' }),
                        icon: "error",
                        text: t(result.message.toLowerCase(), { ns: 'labels' }),
                        showConfirmButton: true,
                        allowOutsideClick: false
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            window.location.href = `/admin/users_and_groups`;
                        }
                    });
                }
            }

            var groupsVoc = (result?.groups) ? result?.groups : [];
            setGroupsVoc(groupsVoc);

            var linked_groups = (result?.linked_groups) ? result?.linked_groups : [];
            setLinkedGroupsDb(linked_groups);

            // Load available groups for permissions management and group selection
            if (type === "user") {
                await loadGroupsForPermissions();
            }

            // Load existing permissions for this user or group
            // I permessi ora vengono caricati insieme ai dati dell'utente/gruppo
            if (result?.rightsPermissions) {
                const transformedPermissions = result.rightsPermissions.map(permission => ({
                    Id: permission.Id,
                    RightsTreeId: permission.RightsTreeId,
                    RightsNodeName: permission.RightsTreeNode?.Name || 'Unknown Node',
                    RightsNodeDescription: permission.RightsTreeNode?.Description || '',
                    Read: permission.Read || false,
                    Write: permission.Write || false,
                    List: permission.List || false,
                    Delete: permission.Delete || false,
                    TakeOwnership: permission.TakeOwnership || false,
                    UserId: permission.UserId,
                    GroupId: permission.GroupId
                }));
                setUserRightsPermissions(transformedPermissions);
            }

        })();
    }, []);

    // Handle click outside to close search results
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Check if clicked element is not part of the search component
            const searchContainer = event.target.closest('.member-search-container');
            if (!searchContainer) {
                setShowMemberSearchResults(false);
            }
        };

        if (showMemberSearchResults) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            // Cleanup timer on unmount
            if (memberSearchTimer) {
                clearTimeout(memberSearchTimer);
            }
        };
    }, [showMemberSearchResults]);

    // Update search results when linked members change
    useEffect(() => {
        if (memberSearchTerm.length >= 3 && showMemberSearchResults) {
            // Re-run search to update filtered results
            searchMembers(memberSearchTerm);
        }
    }, [linkedMembersDB]);


    const setBreadCrumb = (params) => {
        var path = [{
            link: "/",
            name: "Home"
        },
        {
            link: "/admin/users_and_groups",
            name: t('usersAndGroup', { ns: 'labels' })
        }
        ];
        if (type == "group") {
            path.push({
                link: `/admin/group/${id}`,
                name: data?.group?.Name ? data.group.Name : t('newGroup', { ns: 'labels' })
            })
        } else {
            const userName = data?.user?.Name ? data.user.Name : '';
            const userLastName = data?.user?.LastName ? data.user.LastName : t('newUser', { ns: 'labels' });
            path.push({
                link: `/admin/user/${id}`,
                name: `${userName} ${userLastName}`.trim()
            })
        }

        breadcrumb.set(path);

    }
    const getAllUsers = async (searchTerm = '') => {
        var result = await api.sendMessage("admin/security/getAllUsers", {
            user: currentUser(),
            body: {
                id,
                searchTerm: searchTerm
            }
        });

        return result.users;
    }

    // Debounced search for members
    let memberSearchTimer = null;
    
    const searchMembers = async (searchTerm) => {
        if (searchTerm.length < 3) {
            setMemberSearchResults([]);
            setShowMemberSearchResults(false);
            return;
        }

        setIsSearchingMembers(true);
        
        try {
            const users = await getAllUsers(searchTerm);
            // Filter out users that are already members
            const filteredUsers = users?.filter(user => 
                !linkedMembersDB.some(lm => lm.Back_End_User_Id === user.Id)
            ) || [];
            setMemberSearchResults(filteredUsers);
            setShowMemberSearchResults(true);
        } catch (error) {
            console.error("Error searching members:", error);
            setMemberSearchResults([]);
            setShowMemberSearchResults(true); // Still show the dropdown with "no results" message
        } finally {
            setIsSearchingMembers(false);
        }
    };

    const handleMemberSearchChange = (value) => {
        setMemberSearchTerm(value);
        
        // Clear previous timer
        if (memberSearchTimer) {
            clearTimeout(memberSearchTimer);
        }
        
        // Set new timer for debounced search
        memberSearchTimer = setTimeout(() => {
            searchMembers(value);
        }, 300); // 300ms delay
    };

    const handleSelectMemberFromSearch = (userId) => {
        handleAddMemberToGroup(userId);
        setMemberSearchTerm('');
        setMemberSearchResults([]);
        setShowMemberSearchResults(false);
    };

    // Load available groups for permissions management
    const loadGroupsForPermissions = async () => {
        try {
            const result = await api.sendMessage("admin/security/getGroups", {
                user: currentUser()
            });

            if (result?.success && result?.groups) {
                const formattedGroups = result.groups.map(group => ({
                    Id: group.Id,
                    Name: group.Name || 'Unknown Group',
                    Active: group.Active,
                    System: group.System,
                    Deleted: group.Deleted
                }));
                setAvailableGroups(formattedGroups);
            }
        } catch (error) {
            console.error("Error loading groups for permissions:", error);
        }
    };

    // Handle saving group permissions
    const handleSaveGroupPermissions = async () => {
        if (!selectedGroupForPermissions) {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                text: t('groupRequired', { ns: 'labels' }),
                icon: 'error'
            });
            return;
        }

        if (!readPermission && !writePermission && !listPermission && !deletePermission) {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                text: t('permissionsRequired', { ns: 'labels' }),
                icon: 'error'
            });
            return;
        }

        try {
            setSavingPermissions(true);

            const result = await api.sendMessage("admin/security/Set", {
                user: currentUser(),
                body: {
                    UserId: id,
                    GroupIds: [selectedGroupForPermissions],
                    Read: readPermission,
                    Write: writePermission,
                    List: listPermission,
                    Delete: deletePermission,
                    TakeOwnership: false
                }
            });

            if (result?.success) {
                // Find the selected group name
                const selectedGroup = availableGroups.find(g => g.Id === selectedGroupForPermissions);

                // Update local permissions state
                const newPermission = {
                    GroupId: selectedGroupForPermissions,
                    GroupName: selectedGroup?.Name || 'Unknown Group',
                    Read: readPermission,
                    Write: writePermission,
                    List: listPermission,
                    Delete: deletePermission
                };

                // Remove existing permission for this group if exists and add new one
                const updatedPermissions = userGroupPermissions.filter(p => p.GroupId !== selectedGroupForPermissions);
                updatedPermissions.push(newPermission);
                setUserGroupPermissions(updatedPermissions);

                // Clear form
                setSelectedGroupForPermissions('');
                setReadPermission(false);
                setWritePermission(false);
                setListPermission(false);
                setDeletePermission(false);

                userPopUpAction(t('permissionsSaved', { ns: 'labels' }));
            } else {
                throw new Error(result?.error || t('permissionsError', { ns: 'labels' }));
            }
        } catch (error) {
            console.error("Error saving permissions:", error);
            userPopUpAction(t('permissionsError', { ns: 'labels' }));
        } finally {
            setSavingPermissions(false);
        }
    };

    // Handle removing rights node permission
    const handleRemoveRightsNodePermission = (rightsTreeId) => {
        const updatedPermissions = userRightsPermissions.filter(p => p.RightsTreeId !== rightsTreeId);
        setUserRightsPermissions(updatedPermissions);
    };

    // Handle updating rights node permission
    const handleUpdateRightsNodePermission = (rightsTreeId, permissionType, value) => {
        const updatedPermissions = userRightsPermissions.map(permission => {
            if (permission.RightsTreeId === rightsTreeId) {
                return {
                    ...permission,
                    [permissionType]: value
                };
            }
            return permission;
        });
        setUserRightsPermissions(updatedPermissions);
    };

    // Prepare rights permissions data for saving (similar to permissions_manager.js format)
    const prepareRightsPermissionsData = () => {
        if (!userRightsPermissions || userRightsPermissions.length === 0) {
            return [];
        }

        return userRightsPermissions.map(permission => ({
            Id: permission.Id,
            //|| (crypto.randomUUID ? crypto.randomUUID() : 'temp-' + Date.now())
            RightsTreeId: permission.RightsTreeId,
            Read: permission.Read || false,
            Write: permission.Write || false,
            List: permission.List || false,
            Delete: permission.Delete || false,
            TakeOwnership: permission.TakeOwnership || false,
            UserId: type === "user" ? id : null,
            GroupId: type === "group" ? id : null
        }));
    };

    const fromLinksToGroups = () => {

        let realLinkedGroup = groupsVoc.filter(x => linkedGroupsDb.find(y => y.Back_End_Member_Of_Group_Id == x.Id));
        return realLinkedGroup;

    }
    const fromMemberLinksToMember = () => {
        let realLinkedMembers = membersVoc.filter(x => linkedMembersDB.find(y => y.Back_End_User_Id == x.Id));
        return realLinkedMembers;
    }

    useEffect(() => {

        setBreadCrumb();

        if (data?.user) {
            bindField();

            if (data?.user?.Active) {
                window.$("#activateDiv").prop("hidden", true);
                window.$("#deactivateDiv").prop("hidden", null);
            } else {
                window.$("#activateDiv").prop("hidden", null);
                window.$("#deactivateDiv").prop("hidden", true);
            }
        }
        if (type === "group" && data?.group) {
            if (data?.group?.Active) {
                window.$("#activateDiv").prop("hidden", true);
                window.$("#deactivateDiv").prop("hidden", null);
            } else {
                window.$("#activateDiv").prop("hidden", null);
                window.$("#deactivateDiv").prop("hidden", true);
            }

            //change all the user profile label
            window.$("#h5Tilte").text(t('groupEditor'), { ns: 'labels' });

            window.$("#userProfileBreadcrumb").text(t('groupEditor'), { ns: 'labels' });

            bindField();
        }

    }, [data]);

    const updateGroups = async (selectedGroups) => {

        let elementToRemove = linkedGroupsDb.filter(x => !selectedGroups.some(y => y.Id == x.Back_End_Member_Of_Group_Id));

        if (elementToRemove.length > 0) {
            for (var toRemove of elementToRemove) {
                //delete element
                linkedGroupsDb.splice(linkedGroupsDb.findIndex(x => x.Back_End_Member_Of_Group_Id == toRemove.Back_End_Member_Of_Group_Id), 1);
            }
        }

        let elementToAdd = selectedGroups.filter(x => !linkedGroupsDb.some(y => y.Back_End_Member_Of_Group_Id == x.Id));

        if (elementToAdd.length > 0) {

            for (var toAdd of elementToAdd) {
                //delete element
                var newLink = {
                    Back_End_Member_Of_Group_Id: toAdd.Id
                }
                linkedGroupsDb.push(newLink);
            }

        }

        setLinkedGroupsDb(linkedGroupsDb);
    }

    const updateMembers = async (selectedMembers) => {

        let elementToRemove = linkedMembersDB.filter(x => !selectedMembers.some(y => y.Id == x.Back_End_User_Id));

        if (elementToRemove.length > 0) {

            for (var toRemove of elementToRemove) {
                //delete element
                linkedMembersDB.splice(linkedMembersDB.findIndex(x => (x.Back_End_User_Id == toRemove.Back_End_User_Id)), 1);
            }
        }

        let elementToAdd = selectedMembers.filter(x => !linkedMembersDB.some(y => y.Back_End_User_Id == x.Id));

        if (elementToAdd.length > 0) {

            for (var toAdd of elementToAdd) {
                //delete element
                var newLink = {
                    Back_End_User_Id: toAdd.Id,
                    Back_End_Member_Of_Group_Id: id
                }
                linkedMembersDB.push(newLink);
            }
        }

        setLinkedMembersDB(linkedMembersDB);
    }

    const bindField = () => {
        let isActiveText;
        if (data?.user) {

            //main info on the top
            window.$("#main-name").text(`${(data?.user?.Name ? `${data?.user?.Name}` : "")} ${(data?.user?.LastName ? `${data?.user?.LastName}` : "")}`);
            window.$("#main-email").html(`<i class="las la-envelope me-1 fs-18"></i> ${(data?.user?.EMail ? `${data?.user?.EMail}` : "--")}`);


            //Home profile details
            window.$("#profile-fullName").text(`${(data?.user?.Name ? `${data?.user?.Name}` : "-")} ${(data?.user?.LastName ? `${data?.user?.LastName}` : "-")}`);
            window.$("#profile-email").text(`${(data?.user?.EMail ? `${data?.user?.EMail}` : "--")}`);
            window.$("#profile-username").text(`${(data?.user?.UserName ? `${data?.user?.UserName}` : "--")}`);
            isActiveText = data?.user?.Active ? t('activeLabel', { ns: 'labels' }) : t('disactiveLabel', { ns: 'labels' });

            window.$("#profile-activeUser").text(`${isActiveText}`);

            window.$("#profile-passwordExpirationDate").text(`${(data?.user?.PasswordExpirationDate ? `${data?.user?.PasswordExpirationDate.split('T')[0]}` : "--")}`);



            if (data.user.Active) {
                window.$("#settings-activeUser").attr("checked", data.user.Active);
            }

            bindAuthType(data.user.AuthType);
        }
        if (data?.group) {

            window.$("#main-name").text(data?.group?.Name ?? "");
            window.$("#profile-fullName").text(data?.group?.Name ?? "-");

            isActiveText = data?.group?.Active ? t('activeLabel', { ns: 'labels' }) : t('disactiveLabel', { ns: 'labels' });
            window.$("#profile-activeUser").text(`${isActiveText}`);

            if (data.group.Active) {
                window.$("#settings-activeUser").attr("checked", data.group.Active);
            }
        }
    }

    const bindAuthType = (authType) => {
        if (data?.user) {
            switch (authType) {
                case 'local':
                    window.$("#localAuthType").attr("checked", true)
                    break;
                case 'google':
                    window.$("#googleAuthType").attr("checked", true)
                    break;
                case 'oauth':
                    window.$("#oauthAuthType").attr("checked", true)
                    break;
                case 'cas':
                    window.$("#casAuthType").attr("checked", true)
                    break;
                case null:
                    data.user.AuthType = null;
                    break;
                default:
                    data.user.AuthType = null;
            }
        }
    }

    const changeAuthType = (authType) => {

        if (data?.user) {
            switch (authType) {
                case 'local':
                    data.user.AuthType = "local";
                    break;
                case 'google':
                    data.user.AuthType = "google";
                    break;
                case 'oauth':
                    data.user.AuthType = "oauth";
                    break;
                case 'cas':
                    data.user.AuthType = "cas";
                    break;
                case null:
                    data.user.AuthType = null;
                    break;
                default:
                    data.user.AuthType = null;
            }
            setData({ user: data.user });
        }
    }

    const getUser = async (id) => {
        var result = await api.sendMessage("usersGroups/retrieveUser", {
            user: currentUser(),
            body: {
                id
            }
        });

        return result;
    }

    const getGroup = async (id) => {
        var result = await api.sendMessage("usersGroups/getGroup", {
            user: currentUser(),
            body: {
                id
            }
        });
        return result;
    }

    //#region delete user or group
    const openDeleteModal = () => {
        if (type === "group") {
            window.$("#deleteModalHeader").text(t('deleteGroup', { ns: 'labels' }));
            window.$("#deleteParagraph").text(t('deleteGroupConfirm', { ns: 'labels' }));
        } else {
            window.$("#deleteModalHeader").text(t('deleteUser', { ns: 'labels' }));
            window.$("#deleteParagraph").text(t('deleteUserConfirm', { ns: 'labels' }));
        }
        window.$("#deleteModal").modal("show");
    }

    const deleteGroup = async () => {
        var result = await api.sendMessage("usersGroups/deleteGroup", {
            user: currentUser(),
            body: {
                id: id
            }
        });
        if (result.success) {
            if (result.group.deleted) {
                userPopUpAction(t('groupDeletedSuccess', { ns: 'labels' }));
                window.location.href = `/admin/users_and_groups`;
            }
            else {
                userPopUpAction(t('groupDeleteError', { ns: 'labels' }));
                window.$("#deactivateModal").modal("hide");
            }
        } else {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: t(result.message.toLowerCase(), { ns: 'labels' }),
                showConfirmButton: true,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        }
    }

    const deleteMethod = async () => {
        if (type === "group") {
            deleteGroup();
        }
        else if (type == 'user') {
            deleteUser();
        }
    }

    const deleteUser = async () => {
        var result = await api.sendMessage("usersGroups/deleteUser", {
            user: currentUser(),
            body: {
                id: id
            }
        });

        if (result.success) {
            if (result.user.deleted) {
                userPopUpAction(t('userDeletedSuccess', { ns: 'labels' }));
                window.location.href = `/admin/users_and_groups`;
            }
            else {
                userPopUpAction(t('userDeleteError', { ns: 'labels' }));
                window.$("#deactivateModal").modal("hide");
            }
        } else {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: t(result.message.toLowerCase(), { ns: 'labels' }),
                showConfirmButton: true,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        }
    }
    //#endregion

    const openDeactivateModal = () => {
        if (type === "group") {
            window.$("#deactivateModalHeader").text(t('deactivateGroup', { ns: 'labels' }));
            window.$("#deactivateParagraph").text(t('deactivateGroupConfirm', { ns: 'labels' }));
        } else {
            window.$("#deactivateModalHeader").text(t('deactivateUser', { ns: 'labels' }));
            window.$("#deactivateParagraph").text(t('deactivateUserConfirm', { ns: 'labels' }));
        }
        window.$("#deactivateModal").modal("show");
    }

    const openActivateModal = () => {
        if (type === "group") {
            window.$("#activateModalHeader").text(t('activateGroup', { ns: 'labels' }));
            window.$("#activateParagraph").text(t('activateGroupConfirm', { ns: 'labels' }));
        } else {
            window.$("#activateModalHeader").text(t('activateUser', { ns: 'labels' }));
            window.$("#activateParagraph").text(t('activateUserConfirm', { ns: 'labels' }));
        }
        window.$("#activateModal").modal("show");
    }

    //#region  active or deactive group
    const deactivateGroup = async () => {
        var result = await api.sendMessage("usersGroups/deactivateGroup", {
            user: currentUser(),
            body: {
                id: id
            }
        });

        if (result.success) {
            if (result.group.updated) {
                userPopUpAction(t('groupDeactivatedSuccess', { ns: 'labels' }));
                window.$("#deactivateModal").modal("hide");
                setData({ group: result.group.updated });
            }
            else {
                userPopUpAction(t('groupDeactivateError', { ns: 'labels' }));
                window.$("#deactivateModal").modal("hide");
            }
        } else {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: t(result.message.toLowerCase(), { ns: 'labels' }),
                showConfirmButton: true,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        }
    }
    const activateGroup = async () => {
        var result = await api.sendMessage("usersGroups/activateGroup", {
            user: currentUser(),
            body: {
                id: id
            }
        });

        if (result.success) {
            if (result.group.updated) {
                userPopUpAction(t('groupActivatedSuccess', { ns: 'labels' }));
                window.$("#activateModal").modal("hide");
                setData({ group: result.group.updated });
            }
            else {
                userPopUpAction(t('groupActivateError', { ns: 'labels' }));
                window.$("#activateModal").modal("hide");
            }
        } else {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: t(result.message.toLowerCase(), { ns: 'labels' }),
                showConfirmButton: true,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        }
    }
    //#endregion

    //#region  active or deactive user
    const deactivateItem = async () => {
        if (type === "group") {
            deactivateGroup()
        } else if (type === "user") {
            deactivateUser();
        }
    }

    const deactivateUser = async () => {
        var result = await api.sendMessage("usersGroups/deactivateUser", {
            user: currentUser(),
            body: {
                id
            }
        });
        if (result.success) {
            if (result.user.updated) {
                userPopUpAction(t('userDeactivatedSuccess', { ns: 'labels' }));
                window.$("#deactivateModal").modal("hide");
                setData({ user: result.user.updated });
            }
            else {
                userPopUpAction(t('userDeactivateError', { ns: 'labels' }));
                window.$("#deactivateModal").modal("hide");
                setData({ user: result.user.updated });
            }
        } else {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: t(result.message.toLowerCase(), { ns: 'labels' }),
                showConfirmButton: true,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        }
    }

    const activateItem = () => {
        if (type === "group") {
            activateGroup();
        } else if (type === "user") {
            activateUser();
        }
    }

    const activateUser = async () => {
        var result = await api.sendMessage("usersGroups/activateUser", {
            user: currentUser(),
            body: {
                id
            }
        });

        if (result.user.updated) {
            userPopUpAction(t('userActivatedSuccess', { ns: 'labels' }));
            window.$("#activateModal").modal("hide");
            setData({ user: result.user.updated });
        }
        else {
            userPopUpAction(t('userActivateError', { ns: 'labels' }));
            window.$("#activateModal").modal("hide");
            setData({ user: result.user.updated });
        }
    }
    //#endregion

    const createDeleteModal = () => {
        return (<>
            <div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModal" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="deleteModalHeader">{t('deleteUser', { ns: 'labels' })}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div>
                                    <p id="deleteParagraph">{t('deleteUserConfirm', { ns: 'labels' })}</p>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{t('cancel', { ns: 'labels' })}</button>
                            <button id="deactivateUser" type="button" onClick={(e) => {
                                deleteMethod();
                            }} class="btn btn-danger">{t('delete', { ns: 'labels' })}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }




    //#region activate and deactivate modal
    const createDeactiveteModal = () => {
        return (<>
            <div class="modal fade" id="deactivateModal" tabindex="-1" aria-labelledby="deactivateModal" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="deactivateModalHeader">{t('deactivateUser', { ns: 'labels' })}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div>
                                    <p id="deactivateParagraph">{t('deactivateUserConfirm', { ns: 'labels' })}</p>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{t('cancel', { ns: 'labels' })}</button>
                            <button id="deactivateUser" type="button" onClick={(e) => {
                                deactivateItem()
                            }} class="btn btn-danger">{t('deactivate', { ns: 'labels' })}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }

    const createActiveteModal = () => {
        return (<>
            <div class="modal fade" id="activateModal" tabindex="-1" aria-labelledby="activateModal" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="activateModalHeader">{t('activateUser', { ns: 'labels' })}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div>
                                    <p id="activateParagraph">{t('activateUserConfirm', { ns: 'labels' })}</p>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{t('cancel', { ns: 'labels' })}</button>
                            <button id="activateUser" type="button" onClick={(e) => {
                                activateItem();
                            }} class="btn btn-primary">{t('activate', { ns: 'labels' })}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }
    //#endregion

    const userPopUpAction = (text) => {
        let progress_div = window.$(`<div class="col-xl-12" data-progress-id="progress-modal" style="z-index: 99999;">
                                        <div class="card dz-card">
                                            <div class="card-header flex-wrap border-0">
                                                <div>
                                                    <h4 class="card-title">${t('update', { ns: 'labels' })}</h4>
                                                </div>											
                                            </div>
                                            <div class="tab-content">
                                                <div class="tab-pane fade active show" role="tabpanel" aria-labelledby="home-tab10">
                                                    <div class="card-body pt-0">
                                                        <h6><span data-progress-file-name="file-name"></span>
                                                            <span class="pull-end">
                                                          ${text}
                                                            </span>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
    
                                        </div>
                                    </div>`);

        let div = window.$(`<div style="position: fixed; right: 10px; bottom: 10px; width: 450px; height: 200px;"></div>`);
        window.$("body").append(div);
        div.append(progress_div);

        setTimeout(() => {
            div.remove();
        }, 3000);
    }

    const saveGroupData = async () => {
        if (data?.group) {
            let canProceed = true;

            if (data.group.Name == null && data.group.Name !== "") {
                userPopUpAction(t('nameMandatory', { ns: 'labels' }));
                canProceed = false;
            }

            if (canProceed) {
                // Prepare rights permissions data
                const rightsPermissions = prepareRightsPermissionsData();

                var result = await api.sendMessage("usersGroups/saveBackendGroup", {
                    user: currentUser(),
                    body: {
                        group: data.group,
                        linkedGroups: linkedGroupsDb,
                        linkedMembers: linkedMembersDB,
                        rightsPermissions: rightsPermissions
                    }
                });

                if (result.success) {
                    if (result?.group?.updated) {
                        userPopUpAction(t('groupSavedSuccess', { ns: 'labels' }));
                        setData({ group: result.group.updated });
                        if (result.new_link) {
                            for (var nl of result.new_link) {
                                const existingGroupLink = linkedGroupsDb.find(x => x.Back_End_Member_Of_Group_Id == nl.Back_End_Member_Of_Group_Id);
                                if (existingGroupLink) {
                                    existingGroupLink.Id = nl.Id;
                                    existingGroupLink.Back_End_User_Id = nl.Back_End_User_Id;
                                }
                            }
                            setLinkedGroupsDb(linkedGroupsDb);
                        }

                        if (result.new_member) {
                            for (var nm of result.new_member) {
                                const existingMemberLink = linkedMembersDB.find(x => x.Back_End_User_Id == nm.Back_End_User_Id);
                                if (existingMemberLink) {
                                    existingMemberLink.Id = nm.Id;
                                }
                            }
                            setLinkedMembersDB(linkedMembersDB);
                        }

                        // Reload permissions after successful save to show current state
                        if (rightsPermissions.length > 0) {
                            // I permessi vengono ora caricati insieme ai dati del gruppo
                            // Non è più necessario ricaricarli separatamente
                        }

                        // If this is a new group (no id), redirect to the new group's URL
                        if (!id) {
                            window.location.href = `/admin/group/${result.group.updated.Id}`;
                        }
                    }
                    else {
                        userPopUpAction(t('groupSaveError', { ns: 'labels' }));
                    }

                } else {
                    withReactContent(Swal).fire({
                        title: t('error', { ns: 'labels' }),
                        icon: "error",
                        text: t(result.message.toLowerCase(), { ns: 'labels' }),
                        showConfirmButton: true,
                        allowOutsideClick: false
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            window.location.reload();
                        }
                    });
                }
            }
            else {
                userPopUpAction(t('groupNotFound', { ns: 'labels' }));
            }
        } else {
            userPopUpAction(t('groupNotFound', { ns: 'labels' }));
        }
    }

    const saveUserData = async () => {
        if (data?.user) {
            let canProceed = true;

            if (data.user.Name == null && data.user.Name !== "") {
                userPopUpAction(t('nameMandatory', { ns: 'labels' }));
                canProceed = false;
            }
            if (data.user.LastName == null && data.user.LastName !== "") {
                userPopUpAction(t('lastNameMandatory', { ns: 'labels' }));
                canProceed = false;
            }

            if (data.user.AuthType == null) {
                userPopUpAction(t('authTypeMandatory', { ns: 'labels' }));
                canProceed = false;
            }

            if (data.user.EMail == null && data.user.EMail !== "") {
                userPopUpAction(t('emailMandatory', { ns: 'labels' }));
                canProceed = false;
            }
            if (data.user.UserName == null && data.user.UserName !== "") {
                userPopUpAction(t('usernameMandatory', { ns: 'labels' }));
                canProceed = false;
            }

            if (!id && data.user) {
                if (data.user.Password == null && data.user.Password !== "") {
                    userPopUpAction(t('passwordMandatory', { ns: 'labels' }));
                    canProceed = false;
                }
            }

            if (canProceed) {
                // Prepare rights permissions data
                const rightsPermissions = prepareRightsPermissionsData();

                var result = await api.sendMessage("usersGroups/saveUser", {
                    user: currentUser(),
                    body: {
                        user: data.user,
                        linkedGroups: linkedGroupsDb,
                        rightsPermissions: rightsPermissions
                    }
                });

                if (result.success) {
                    if (result.user?.updated) {
                        userPopUpAction(t('userSavedSuccess', { ns: 'labels' }));
                        setData({ user: result.user.updated });
                        if (result.new_link) {
                            for (var nl of result.new_link) {
                                const existingLink = linkedGroupsDb.find(x => x.Back_End_Member_Of_Group_Id == nl.Back_End_Member_Of_Group_Id);
                                if (existingLink) {
                                    existingLink.Id = nl.Id;
                                    existingLink.Back_End_User_Id = nl.Back_End_User_Id;
                                }
                            }
                            setLinkedGroupsDb(linkedGroupsDb);
                        }

                        // Reload permissions after successful save to show current state
                        if (rightsPermissions.length > 0) {
                            // I permessi vengono ora caricati insieme ai dati del gruppo
                            // Non è più necessario ricaricarli separatamente
                        }

                        if (!id) {
                            window.location.href = `/admin/user/${data.user.Id}`;
                        }
                    }
                    else {
                        if (result.requirements) {
                            const validationPasswordError = [];

                            if (!result.requirements.lowercase) {
                                validationPasswordError.push(t('lowercase', { ns: 'labels' }));
                            }
                            if (!result.requirements.uppercase) {
                                validationPasswordError.push(t('uppercase', { ns: 'labels' }));
                            }
                            if (!result.requirements.numbers) {
                                validationPasswordError.push(t('number', { ns: 'labels' }));
                            }
                            if (!result.requirements.minLength) {
                                validationPasswordError.push(t('minLength', { ns: 'labels' }));
                            }
                            if (!result.requirements.symbols) {
                                validationPasswordError.push(t('symbols', { ns: 'labels' }));
                            }
                            if (!result.requirements.notUsedRecently) {
                                validationPasswordError.push(t('notUsedRecently', { ns: 'labels' }));
                            }


                            if (validationPasswordError.length > 0) {
                                userPopUpAction(validationPasswordError.join(', '));
                            }
                        } else {
                            userPopUpAction(t('userSaveError', { ns: 'labels' }));
                        }
                    }
                } else {


                    if (result.requirements) {
                        const validationPasswordError = [];

                        if (!result.requirements.lowercase) {
                            validationPasswordError.push(t('lowercase', { ns: 'labels' }));
                        }
                        if (!result.requirements.uppercase) {
                            validationPasswordError.push(t('uppercase', { ns: 'labels' }));
                        }
                        if (!result.requirements.numbers) {
                            validationPasswordError.push(t('number', { ns: 'labels' }));
                        }
                        if (!result.requirements.minLength) {
                            validationPasswordError.push(t('minLength', { ns: 'labels' }));
                        }
                        if (!result.requirements.symbols) {
                            validationPasswordError.push(t('symbols', { ns: 'labels' }));
                        }
                        if (!result.requirements.notUsedRecently) {
                            validationPasswordError.push(t('notUsedRecently', { ns: 'labels' }));
                        }


                        if (validationPasswordError.length > 0) {
                            userPopUpAction(validationPasswordError.join(', '));
                        }
                    } else {
                        withReactContent(Swal).fire({
                            title: t('error', { ns: 'labels' }),
                            icon: "error",
                            text: t(result.message.toLowerCase(), { ns: 'labels' }),
                            showConfirmButton: true,
                            allowOutsideClick: false
                        }).then(async (result) => {
                            if (result.isConfirmed) {
                                window.location.reload();
                            }
                        });                    }
                   


                    
                }
            }
        } else {
            userPopUpAction(t('userNotFound', { ns: 'labels' }));
        }
    }

    const drawTopHeader = () => {
        if (data?.user) {
            //#region user
            return (<>
                <div class="card-header">
                    <h4 id="h4CardTitle" class="card-title">{t('userProfile', { ns: 'labels' })}</h4>
                </div>
                <div class="card-body d-flex">
                    <div class="clearfix">
                        <div class="d-inline-block position-relative me-sm-4 me-3 mb-3 mb-lg-0">
                            <img src={standardPic} alt="" class="rounded-4 profile-avatar" />
                            <span class="fa fa-circle border border-3 border-white text-success position-absolute bottom-0 end-0 rounded-circle"></span>
                        </div>
                    </div>
                    <div class="clearfix d-xl-flex flex-grow-1">
                        <div class="clearfix pe-md-5">
                            <h3 id="main-name" class="fw-semibold mb-1">...</h3>
                            {id ? <ul class="d-flex flex-wrap fs-6 align-items-center">

                                <li id="main-email" class="me-3 d-inline-flex align-items-center"><i class="las la-envelope me-1 fs-18"></i>{data?.user?.EMail ? `${data?.user?.EMail}` : ""}</li>
                            </ul> : (null)}
                        </div>
                    </div>
                </div>
                <div class="card-footer py-0 d-flex flex-wrap justify-content-between align-items-center">
                    <ul class="nav nav-underline nav-underline-primary nav-underline-text-dark nav-underline-gap-x-0" id="tabMyProfileBottom" role="tablist">
                        <li class="nav-item ms-1" role="presentation">
                            <button id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" class="nav-link py-3 border-3 text-dark active">{t('home', { ns: 'labels' })}</button>
                        </li>
                        <li class="nav-item ms-1" role="presentation">
                            <button class="nav-link py-3 border-3 text-dark " id="nav-settings-tab" data-bs-toggle="tab" data-bs-target="#nav-settings" type="button" role="tab" aria-controls="nav-settings" aria-selected="false">{t('profile', { ns: 'labels' })}</button>
                        </li>
                    </ul>
                    <ul class="d-xl-flex d-none py-2">
                        <li class="px-1">
                            <a class="btn btn-light btn-sharp" href="javascript:void(0);">
                                <i class="fa-brands fa-linkedin-in"></i>
                            </a>
                        </li>
                        <li class="px-1">
                            <a class="btn btn-light btn-sharp" href="javascript:void(0);">
                                <i class="fa-brands fa-instagram"></i>
                            </a>
                        </li>
                        <li class="px-1">
                            <a class="btn btn-light btn-sharp" href="javascript:void(0);">
                                <i class="fa-brands fa-facebook-f"></i>
                            </a>
                        </li>
                        <li class="px-1">
                            <a class="btn btn-light btn-sharp" href="javascript:void(0);">
                                <i class="fa-brands fa-telegram"></i>
                            </a>
                        </li>
                        <li class="px-1">
                            <a class="btn btn-light btn-sharp" href="javascript:void(0);">
                                <i class="fa-brands fa-youtube"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </>)
        }
        else if (data?.group) {
            //#region group
            return (<>
                <div class="card-header">
                    <h4 id="h4CardTitle" class="card-title">{t('groupProfile', { ns: 'labels' })}</h4>
                </div>
                <div class="card-body d-flex">
                    <div class="clearfix">
                        <div class="d-inline-block position-relative me-sm-4 me-3 mb-3 mb-lg-0">
                            <img src={standardPic} alt="" class="rounded-4 profile-avatar" />
                            <span class="fa fa-circle border border-3 border-white text-success position-absolute bottom-0 end-0 rounded-circle"></span>
                        </div>
                    </div>
                    <div class="clearfix d-xl-flex flex-grow-1">
                        <div class="clearfix pe-md-5">
                            <h3 id="main-name" class="fw-semibold mb-1">...</h3>
                        </div>
                    </div>
                </div>
                <div class="card-footer py-0 d-flex flex-wrap justify-content-between align-items-center">
                    <ul class="nav nav-underline nav-underline-primary nav-underline-text-dark nav-underline-gap-x-0" id="tabMyProfileBottom" role="tablist">
                        <li class="nav-item ms-1" role="presentation">
                            <button id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" class="nav-link py-3 border-3 text-dark active">{t('home', { ns: 'labels' })}</button>
                        </li>
                        <li class="nav-item ms-1" role="presentation">
                            <button class="nav-link py-3 border-3 text-dark " id="nav-settings-tab" data-bs-toggle="tab" data-bs-target="#nav-settings" type="button" role="tab" aria-controls="nav-settings" aria-selected="false">{t('editGroup', { ns: 'labels' })}</button>
                        </li>
                    </ul>
                    <ul class="d-xl-flex d-none py-2">
                        <li class="px-1">
                            <a class="btn btn-light btn-sharp" href="javascript:void(0);">
                                <i class="fa-brands fa-linkedin-in"></i>
                            </a>
                        </li>
                        <li class="px-1">
                            <a class="btn btn-light btn-sharp" href="javascript:void(0);">
                                <i class="fa-brands fa-instagram"></i>
                            </a>
                        </li>
                        <li class="px-1">
                            <a class="btn btn-light btn-sharp" href="javascript:void(0);">
                                <i class="fa-brands fa-facebook-f"></i>
                            </a>
                        </li>
                        <li class="px-1">
                            <a class="btn btn-light btn-sharp" href="javascript:void(0);">
                                <i class="fa-brands fa-telegram"></i>
                            </a>
                        </li>
                        <li class="px-1">
                            <a class="btn btn-light btn-sharp" href="javascript:void(0);">
                                <i class="fa-brands fa-youtube"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </>)
        }
    }

    const drawHomePanel = () => {
        if (data?.user) {
            //#region user
            return (<>
                <div class="tab-content">
                    <div class="row">
                        <div class="col-xl-5">
                            <div class="card">
                                <div class="card-header py-3">
                                    <h6 class="card-title">{t('profileDetails', { ns: 'labels' })}</h6>
                                </div>
                                <div class="card-body">
                                    <div class="row py-2">
                                        <div class="col-6">
                                            <span class="fs-13">{t('fullName', { ns: 'labels' })}</span>
                                        </div>
                                        <div class="col-6">
                                            <span id="profile-fullName" class="fs-13 text-secondary fw-semibold">Brad Dennis</span>
                                        </div>
                                    </div>
                                    <div class="row py-2">
                                        <div class="col-6">
                                            <span class="fs-13">{t('email', { ns: 'labels' })}</span>
                                        </div>
                                        <div class="col-6">
                                            <span id="profile-email" class="fs-13 text-secondary fw-semibold"></span>
                                        </div>
                                    </div>
                                    <div class="row py-2">
                                        <div class="col-6">
                                            <span class="fs-13">{t('username', { ns: 'labels' })}</span>
                                        </div>
                                        <div class="col-6">
                                            <span id="profile-username" class="fs-13 text-secondary fw-semibold">123 456 7890</span>
                                        </div>
                                    </div>
                                    <div class="row py-2">
                                        <div class="col-6">
                                            <span class="fs-13">{t('passwordExpirationDate', { ns: 'labels' })}</span>
                                        </div>
                                        <div class="col-6">
                                            <span id="profile-passwordExpirationDate" class="fs-13 text-secondary fw-semibold">Yes</span>
                                        </div>
                                    </div>

                                    <div class="row py-2">
                                        <div class="col-6">
                                            <span class="fs-13">{t('active', { ns: 'labels' })}</span>
                                        </div>
                                        <div class="col-6">
                                            <span id="profile-activeUser" class="fs-13 text-secondary fw-semibold">Yes</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-6">
                            <div class="card">
                                <div class="card-header pb-0 border-0">
                                    <div class="clearfix">
                                        <h4 class="card-title mb-0">{t('yourGroups', { ns: 'labels' })}</h4>
                                    </div>
                                </div>
                                <div class="card-body" id="group-list-rd">
                                    {_drawGroupListReadOnly()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
        }
        else if (data?.group) {
            //#region group
            return (<>
                <div class="tab-content">
                    <div class="row">
                        <div class="col-xl-4">
                            <div class="card">
                                <div class="card-header py-3">
                                    <h6 class="card-title">{t('profileDetails', { ns: 'labels' })}</h6>
                                </div>
                                <div class="card-body">
                                    <div class="row py-2">
                                        <div class="col-6">
                                            <span class="fs-13">{t('name', { ns: 'labels' })}</span>
                                        </div>
                                        <div class="col-6">
                                            <span id="profile-fullName" class="fs-13 text-secondary fw-semibold">{t('newGroup', { ns: 'labels' })}</span>
                                        </div>
                                    </div>
                                    <div class="row py-2">
                                        <div class="col-6">
                                            <span class="fs-13">{t('active', { ns: 'labels' })}</span>
                                        </div>
                                        <div class="col-6">
                                            <span id="profile-activeUser" class="fs-13 text-secondary fw-semibold">{t('yes', { ns: 'labels' })}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6">
                            <div class="card">
                                <div class="card-header pb-0 border-0">
                                    <div class="clearfix">
                                        <h4 class="card-title mb-0">{t('yourGroups', { ns: 'labels' })}</h4>
                                    </div>
                                </div>
                                <div class="card-body">
                                    {_drawGroupListReadOnly()}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6">
                            <div class="card">
                                <div class="card-header pb-0 border-0">
                                    <div class="clearfix">
                                        <h4 class="card-title mb-0">{t('yourUsers', { ns: 'labels' })}</h4>
                                    </div>
                                </div>
                                <div class="card-body">
                                    {_drawUsersListReadOnly()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
        }
    }

    const drawSettingsPanel = () => {

        if (data?.user) {
            //#region user
            return (
                <>
                    <div class="row">
                        <div id="divBasicInfo" class="col-xl-8">
                            <div>
                                <div class="card">
                                    <div class="card-header">
                                        <h6 class="card-title">{t('basicInfo', { ns: 'labels' })}</h6>
                                    </div>
                                    <div class="card-body">

                                        <div id="divEditAvatar" class="row mb-4">
                                            <div class="col-md-3">
                                                <label class="form-label mb-md-0">Avatar</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="d-inline-block position-relative me-4 mb-3 mb-lg-0">
                                                    <img src="images/avatar/pic7.jpg" alt="" class="rounded-4 profile-avatar" />
                                                    <button type="button" class="btn btn-primary btn-sharp position-absolute bottom-0 end-0">
                                                        <i class="fa-solid fa-pen-to-square"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row align-items-center mb-4">
                                            <div class="col-md-3">
                                                <label id="fullNameLabel" class="form-label mb-md-0">{t('fullName', { ns: 'labels' })}</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <input id="settings-name" type="text" class="form-control" placeholder={t('namePlaceholder', { ns: 'labels' })} value={data?.user?.Name}
                                                            onChange={(e) => {

                                                                data.user.Name = e.target.value;
                                                                setData({ user: data.user });


                                                            }}
                                                        />
                                                    </div>
                                                    <div id="divEditLastName" class="col-sm-6 mt-2 mt-sm-0">
                                                        <input id="settings-lastname" type="text" class="form-control" placeholder={t('lastNamePlaceholder', { ns: 'labels' })} value={data?.user?.LastName}
                                                            onChange={(e) => {
                                                                data.user.LastName = e.target.value;
                                                                setData({ user: data.user });
                                                            }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="divEditEmail" class="row align-items-center mb-4">
                                            <div class="col-md-3">
                                                <label class="form-label mb-md-0">{t('email', { ns: 'labels' })}</label>
                                            </div>
                                            <div class="col-md-9">
                                                <input id="settings-email"
                                                    onChange={(e) => {
                                                        data.user.EMail = e.target.value;
                                                        setData({ user: data.user });
                                                    }} type="text" class="form-control" placeholder={t('emailPlaceholder', { ns: 'labels' })} value={data?.user?.EMail}
                                                />
                                            </div>
                                        </div>
                                        <div id="divEditUsername" class="row align-items-center mb-4">
                                            <div class="col-md-3">
                                                <label class="form-label mb-md-0">{t('username', { ns: 'labels' })}</label>
                                            </div>
                                            <div class="col-md-9">
                                                <input id="settings-username" type="text" class="form-control" placeholder={t('usernamePlaceholder', { ns: 'labels' })} value={data?.user?.UserName}
                                                    onChange={(e) => {

                                                        data.user.UserName = e.target.value;
                                                        setData({ user: data.user });


                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div id="divEditPassword" class="row align-items-center mb-4">
                                            <div class="col-md-3">
                                                <label class="form-label mb-md-0">{t('password', { ns: 'labels' })}</label>
                                            </div>
                                            <div class="col-md-9 position-relative">
                                                <input id="settings-password" type="text" class="form-control" placeholder={t('passwordPlaceholder', { ns: 'labels' })}
                                                    onChange={(e) => {
                                                        data.user.Password = e.target.value;
                                                        setData({ user: data.user });
                                                    }}
                                                    onFocus={(e) => {
                                                        const tooltip = document.createElement('div');
                                                        tooltip.id = 'password-tooltip';
                                                        tooltip.className = 'position-absolute bg-light border p-2 rounded shadow-sm';
                                                        tooltip.style.zIndex = '1000';
                                                        tooltip.style.minWidth = '300px';
                                                        tooltip.style.maxWidth = '400px';
                                                        tooltip.innerHTML = `
                                                            <div class="password-info">
                                                                <h6 class="mb-2">${t('passwordRequirements', { ns: 'labels' })}</h6>
                                                                <ul class="mb-0 ps-3">
                                                                    <li>${t('passwordInfo', { ns: 'labels' })}</li>
                                                                </ul>
                                                            </div>
                                                        `;
                                                        
                                                        // Position the tooltip below the input field
                                                        const inputRect = e.target.getBoundingClientRect();
                                                        const tooltipHeight = 80; // Approximate height of tooltip
                                                        const offset = 5; // Space between tooltip and input
                                                        
                                                        tooltip.style.top = `${inputRect.bottom + offset}px`;
                                                        tooltip.style.left = `${inputRect.left}px`;
                                                        
                                                        document.body.appendChild(tooltip);
                                                    }}
                                                    onBlur={() => {
                                                        const tooltip = document.getElementById('password-tooltip');
                                                        if (tooltip) {
                                                            tooltip.remove();
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>


                                        <div id="divEditPasswordExpirationDate" class="row align-items-center mb-4">
                                            <div class="col-md-3">
                                                <label class="form-label mb-md-0">{t('passwordExpirationDate', { ns: 'labels' })}</label>
                                            </div>
                                            <div class="col-md-9">
                                                <input id="settings-passwordExpirationDate" type="date" class="form-control"
                                                    value={data?.user?.PasswordExpirationDate ? new Date(data?.user?.PasswordExpirationDate).toISOString().split('T')[0] : ''}
                                                    onChange={(e) => {
                                                        data.user.PasswordExpirationDate = e.target.value;
                                                        setData({ user: data.user });
                                                    }}
                                                />
                                            </div>
                                        </div>


                                        <div class="row align-items-center mb-3">
                                            <div class="col-md-3">
                                                <label class="form-label mb-md-0">{t('active', { ns: 'labels' })}</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" id="settings-activeUser" disabled />
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div class="card">
                                    <div class="card-body">
                                        <div class="mb-4">
                                            <h4 class="card-title">{t('yourGroups', { ns: 'labels' })}</h4>
                                            <p>{t('addRemoveGroups', { ns: 'labels' })}</p>
                                        </div>

                                        {/* Dropdown per selezionare gruppi */}
                                        <div class="mb-3">
                                            <label class="form-label">{t('selectGroupToManage', { ns: 'labels' })}</label>
                                            <div class="d-flex gap-2">
                                                <select
                                                    class="form-select"
                                                    value=""
                                                    onChange={(e) => {
                                                        if (e.target.value) {
                                                            handleAddGroupToUser(e.target.value);
                                                            e.target.value = ""; // Reset selection
                                                        }
                                                    }}
                                                >
                                                    <option value="">{t('selectGroupToManage', { ns: 'labels' })}</option>
                                                    {availableGroups && availableGroups
                                                        .filter(group => !linkedGroupsDb.some(lg => lg.Back_End_Member_Of_Group_Id === group.Id))
                                                        .map(group => (
                                                            <option key={group.Id} value={group.Id}>
                                                                {group.Name}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>
                                        </div>

                                        {/* Lista gruppi selezionati */}
                                        <div class="mb-3">
                                            <label class="form-label">{t('assignedGroups', { ns: 'labels' })}</label>
                                            {linkedGroupsDb && linkedGroupsDb.length > 0 ? (
                                                <div class="list-group">
                                                    {linkedGroupsDb.map(lg => {
                                                        const group = availableGroups.find(g => g.Id === lg.Back_End_Member_Of_Group_Id);
                                                        return group ? (
                                                            <div key={lg.Back_End_Member_Of_Group_Id} class="list-group-item d-flex justify-content-between align-items-center">
                                                                <div class="d-flex align-items-center">
                                                                    <i class="fas fa-users text-primary me-3"></i>
                                                                    <span class="fw-semibold">{group.Name}</span>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-sm btn-outline-danger"
                                                                    onClick={() => handleRemoveGroupFromUser(lg.Back_End_Member_Of_Group_Id)}
                                                                    title={t('remove', { ns: 'labels' })}
                                                                >
                                                                    <i class="fas fa-times"></i>
                                                                </button>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            ) : (
                                                <div class="alert alert-info">
                                                    <p class="mb-0">{t('noGroupsAssigned', { ns: 'labels' })}</p>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>

                                {/* Sezione Permessi Utente */}
                                <div class="card">
                                    <div class="card-header">
                                        <h6 class="card-title">{t('userPermissions', { ns: 'labels' })}</h6>
                                    </div>
                                    <div class="card-body">
                                        {_drawPermissionsListReadOnly()}
                                    </div>
                                </div>



                            </div>


                        </div>
                        <div id="divAuthTypeNotification" class="col-xl-4">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card">
                                        <div class="card-header">
                                            <div class="clearfix">
                                                <h4 class="card-title mb-0">{t('connectedAccounts', { ns: 'labels' })}</h4>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="alert alert-primary border-primary outline-dashed py-3 px-3 mt-1 mb-3 mb-0 text-dark d-flex">
                                                <div class="clearfix">
                                                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd" d="M27.75 12C29.8211 12 31.5 10.3211 31.5 8.25C31.5 6.17893 29.8211 4.5 27.75 4.5C25.6789 4.5 24 6.17893 24 8.25C24 10.3211 25.6789 12 27.75 12ZM27.75 31.5C29.8211 31.5 31.5 29.8211 31.5 27.75C31.5 25.6789 29.8211 24 27.75 24C25.6789 24 24 25.6789 24 27.75C24 29.8211 25.6789 31.5 27.75 31.5ZM12 27.75C12 29.8211 10.3211 31.5 8.25 31.5C6.17893 31.5 4.5 29.8211 4.5 27.75C4.5 25.6789 6.17893 24 8.25 24C10.3211 24 12 25.6789 12 27.75Z" fill="#0D99FF"></path>
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.25 12C10.3211 12 12 10.3211 12 8.25C12 6.17893 10.3211 4.5 8.25 4.5C6.17893 4.5 4.5 6.17893 4.5 8.25C4.5 10.3211 6.17893 12 8.25 12ZM15 7C15 6.44772 15.4477 6 16 6H20C20.5523 6 21 6.44772 21 7V8C21 8.55229 20.5523 9 20 9H16C15.4477 9 15 8.55229 15 8V7ZM16 27C15.4477 27 15 27.4477 15 28V29C15 29.5523 15.4477 30 16 30H20C20.5523 30 21 29.5523 21 29V28C21 27.4477 20.5523 27 20 27H16ZM6 16C6 15.4477 6.44772 15 7 15H8C8.55229 15 9 15.4477 9 16V20C9 20.5523 8.55229 21 8 21H7C6.44772 21 6 20.5523 6 20V16ZM28 15C27.4477 15 27 15.4477 27 16V20C27 20.5523 27.4477 21 28 21H29C29.5523 21 30 20.5523 30 20V16C30 15.4477 29.5523 15 29 15H28Z" fill="#0D99FF"></path>
                                                    </svg>
                                                </div>
                                                <div class="mx-3">
                                                    {t('userCanUseLogin', { ns: 'labels' })}
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center border-bottom border-light py-3">
                                                <div class="avatar avatar-md rounded d-flex align-items-center justify-content-center bg-white">
                                                    <img src={localLogo} alt="" />
                                                </div>
                                                <div class="clearfix ms-2">
                                                    <h6 class="fs-14 mb-0 fw-semibold">Local</h6>
                                                    <span class="fs-13">{t('useLocalAccess', { ns: 'labels' })}</span>
                                                </div>
                                                <div class="clearfix ms-auto">
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="radio" name="authType" role="switch" id="localAuthType" onChange={(e) => {

                                                            if (e.target.checked) {
                                                                changeAuthType("local");
                                                            } else {
                                                                changeAuthType(null);
                                                            }
                                                        }
                                                        } />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center border-bottom border-light py-3">
                                                <div class="avatar avatar-md rounded d-flex align-items-center justify-content-center bg-white">
                                                    <img src={googleLogo} alt="" />
                                                </div>
                                                <div class="clearfix ms-2">
                                                    <h6 class="fs-14 mb-0 fw-semibold">Google</h6>
                                                    <span class="fs-13">{t('useGoogleSSO', { ns: 'labels' })}</span>
                                                </div>
                                                <div class="clearfix ms-auto">
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="radio" name="authType" role="switch" id="googleAuthType" onChange={(e) => {

                                                            if (e.target.checked) {
                                                                changeAuthType("google");
                                                            } else {
                                                                changeAuthType(null);
                                                            }
                                                        }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center py-3">
                                                <div class="avatar avatar-md d-flex align-items-center justify-content-center bg-white">
                                                    <img src={oauthLogo} alt="" style={{maxWidth: '24px', maxHeight: '24px'}} />
                                                </div>
                                                <div class="clearfix ms-2">
                                                    <h6 class="fs-14 mb-0 fw-semibold">OAuth 2.0</h6>
                                                    <span class="fs-13">Usa SSO con oauth</span>
                                                </div>
                                                <div class="clearfix ms-auto">
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="radio" name="authType" role="switch" id="oauthAuthType"
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    changeAuthType("oauth");
                                                                } else {
                                                                    changeAuthType(null);
                                                                }
                                                            }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center py-3">
                                                <div class="avatar avatar-md d-flex align-items-center justify-content-center bg-white">
                                                    <img src={casLogo} alt="" />
                                                </div>
                                                <div class="clearfix ms-2">
                                                    <h6 class="fs-14 mb-0 fw-semibold">CAS</h6>
                                                    <span class="fs-13">{t('useCASLogin', { ns: 'labels' })}</span>
                                                </div>
                                                <div class="clearfix ms-auto">
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="radio" name="authType" role="switch" id="casAuthType"
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    changeAuthType("cas");
                                                                } else {
                                                                    changeAuthType(null);
                                                                }
                                                            }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="card">
                                        <div class="card-header">
                                            <h4 class="heading mb-0">{t('notifications', { ns: 'labels' })}</h4>
                                        </div>
                                        <div class="card-body">
                                            <form action="#" class="mt-2">
                                                <div class="clearfix border-bottom border-light py-3">
                                                    <div class="row align-items-center">
                                                        <div class="col-sm-6">
                                                            <label class="form-label mb-md-0">{t('notifications', { ns: 'labels' })}</label>
                                                        </div>
                                                        <div class="col-sm-3 col-6">
                                                            <div class="form-check custom-checkbox me-4 mb-0 d-inline-block">
                                                                <input type="checkbox" class="form-check-input mb-0" id="checkboxNotEmail" />
                                                                <label class="form-check-label mb-0" for="checkboxNotEmail">{t('email', { ns: 'labels' })}</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3 col-6">
                                                            <div class="form-check custom-checkbox me-4 mb-0 d-inline-block">
                                                                <input type="checkbox" class="form-check-input mb-0" id="checkboxNotPhone" />
                                                                <label class="form-check-label mb-0" for="checkboxNotPhone">{t('phone', { ns: 'labels' })}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div class="clearfix border-bottom border-light py-3">
                                                    <div class="row align-items-center">
                                                        <div class="col-sm-6">
                                                            <label class="form-label mb-md-0">Billing Updates</label>
                                                        </div>
                                                        <div class="col-sm-3 col-6">
                                                            <div class="form-check custom-checkbox me-4 mb-0 d-inline-block">
                                                                <input type="checkbox" class="form-check-input mb-0" id="checkboxBillEmail" />
                                                                <label class="form-check-label mb-0" for="checkboxBillEmail">Email</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3 col-6">
                                                            <div class="form-check custom-checkbox me-4 mb-0 d-inline-block">
                                                                <input type="checkbox" class="form-check-input mb-0" id="checkboxBillPhone" />
                                                                <label class="form-check-label mb-0" for="checkboxBillPhone">Phone</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div class="clearfix border-bottom border-light py-3">
                                                    <div class="row align-items-center">
                                                        <div class="col-sm-6">
                                                            <label class="form-label mb-md-0">{t('newTeamMembers', { ns: 'labels' })}</label>
                                                        </div>
                                                        <div class="col-sm-3 col-6">
                                                            <div class="form-check custom-checkbox me-4 mb-0 d-inline-block">
                                                                <input type="checkbox" class="form-check-input mb-0" id="checkboxTeamEmail" />
                                                                <label class="form-check-label mb-0" for="checkboxTeamEmail">{t('email', { ns: 'labels' })}</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3 col-6">
                                                            <div class="form-check custom-checkbox me-4 mb-0 d-inline-block">
                                                                <input type="checkbox" class="form-check-input mb-0" id="checkboxTeamPhone" />
                                                                <label class="form-check-label mb-0" for="checkboxTeamPhone">{t('phone', { ns: 'labels' })}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="clearfix border-bottom border-light py-3">
                                                    <div class="row align-items-center">
                                                        <div class="col-sm-6">
                                                            <label class="form-label mb-md-0">{t('completedProjects', { ns: 'labels' })}</label>
                                                        </div>
                                                        <div class="col-sm-3 col-6">
                                                            <div class="form-check custom-checkbox me-4 mb-0 d-inline-block">
                                                                <input type="checkbox" class="form-check-input mb-0" id="checkboxProEmail" />
                                                                <label class="form-check-label mb-0" for="checkboxProEmail">{t('email', { ns: 'labels' })}</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3 col-6">
                                                            <div class="form-check custom-checkbox me-4 mb-0 d-inline-block">
                                                                <input type="checkbox" class="form-check-input mb-0" id="checkboxProPhone" />
                                                                <label class="form-check-label mb-0" for="checkboxProPhone">{t('phone', { ns: 'labels' })}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="clearfix py-3">
                                                    <div class="row align-items-center">
                                                        <div class="col-sm-6">
                                                            <label class="form-label mb-md-0">{t('newsletters', { ns: 'labels' })}</label>
                                                        </div>
                                                        <div class="col-sm-3 col-6">
                                                            <div class="form-check custom-checkbox me-4 mb-0 d-inline-block">
                                                                <input type="checkbox" class="form-check-input mb-0" id="checkboxNewsEmail" />
                                                                <label class="form-check-label mb-0" for="checkboxNewsEmail">{t('email', { ns: 'labels' })}</label>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3 col-6">
                                                            <div class="form-check custom-checkbox me-4 mb-0 d-inline-block">
                                                                <input type="checkbox" class="form-check-input mb-0" id="checkboxNewsPhone" />
                                                                <label class="form-check-label mb-0" for="checkboxNewsPhone">{t('phone', { ns: 'labels' })}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div id="deactivateDiv" class="col-xl-6" >
                            <div class="card">
                                <div class="card-header">
                                    <h4 class="heading mb-0">{t('deactivateAccount', { ns: 'labels' })}</h4>
                                </div>
                                <div class="card-body">
                                    <div class="alert alert-warning border-warning outline-dashed py-3 px-3 mt-1 mb-4 mb-0 text-dark d-flex align-items-center">
                                        <div class="clearfix">
                                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 11.0218 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0C11.0218 0 7.20644 1.58035 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C7.20644 28.4196 11.0218 30 15 30ZM12.6562 19.6875H14.0625V15.9375H12.6562C11.877 15.9375 11.25 15.3105 11.25 14.5312C11.25 13.752 11.877 13.125 12.6562 13.125H15.4688C16.248 13.125 16.875 13.752 16.875 14.5312V19.6875H17.3438C18.123 19.6875 18.75 20.3145 18.75 21.0938C18.75 21.873 18.123 22.5 17.3438 22.5H12.6562C11.877 22.5 11.25 21.873 11.25 21.0938C11.25 20.3145 11.877 19.6875 12.6562 19.6875ZM15 7.5C15.4973 7.5 15.9742 7.69754 16.3258 8.04918C16.6775 8.40081 16.875 8.87772 16.875 9.375C16.875 9.87228 16.6775 10.3492 16.3258 10.7008C15.9742 11.0525 15.4973 11.25 15 11.25C14.5027 11.25 14.0258 11.0525 13.6742 10.7008C13.3225 10.3492 13.125 9.87228 13.125 9.375C13.125 8.87772 13.3225 8.40081 13.6742 8.04918C14.0258 7.69754 14.5027 7.5 15 7.5Z" fill="#FF8A11"></path>
                                            </svg>
                                        </div>
                                        <div class="mx-3">
                                            <h6 class="mb-0 fw-semibold">{t('deactivateAccountMessage', { ns: 'labels' })}</h6>
                                        </div>
                                    </div>
                                    <div class="text-end">
                                        <button onClick={() => {
                                            openDeactivateModal()
                                        }} class="btn btn-danger ms-2">{t('deactivateAccount', { ns: 'labels' })}</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div id="activateDiv" class="col-xl-6" >
                            <div class="card">
                                <div class="card-header">
                                    <h4 class="heading mb-0">{t('activateAccount', { ns: 'labels' })}</h4>
                                </div>
                                <div class="card-body">
                                    <div class="alert alert-warning border-warning outline-dashed py-3 px-3 mt-1 mb-4 mb-0 text-dark d-flex align-items-center">
                                        <div class="clearfix">
                                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 11.0218 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0C11.0218 0 7.20644 1.58035 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C7.20644 28.4196 11.0218 30 15 30ZM12.6562 19.6875H14.0625V15.9375H12.6562C11.877 15.9375 11.25 15.3105 11.25 14.5312C11.25 13.752 11.877 13.125 12.6562 13.125H15.4688C16.248 13.125 16.875 13.752 16.875 14.5312V19.6875H17.3438C18.123 19.6875 18.75 20.3145 18.75 21.0938C18.75 21.873 18.123 22.5 17.3438 22.5H12.6562C11.877 22.5 11.25 21.873 11.25 21.0938C11.25 20.3145 11.877 19.6875 12.6562 19.6875ZM15 7.5C15.4973 7.5 15.9742 7.69754 16.3258 8.04918C16.6775 8.40081 16.875 8.87772 16.875 9.375C16.875 9.87228 16.6775 10.3492 16.3258 10.7008C15.9742 11.0525 15.4973 11.25 15 11.25C14.5027 11.25 14.0258 11.0525 13.6742 10.7008C13.3225 10.3492 13.125 9.87228 13.125 9.375C13.125 8.87772 13.3225 8.40081 13.6742 8.04918C14.0258 7.69754 14.5027 7.5 15 7.5Z" fill="#FF8A11"></path>
                                            </svg>
                                        </div>
                                        <div class="mx-3">
                                            <h6 class="mb-0 fw-semibold">{t('activateAccountMessage', { ns: 'labels' })}</h6>
                                        </div>
                                    </div>
                                    <div class="text-end">
                                        <button onClick={() => {
                                            openActivateModal();
                                        }} class="btn btn-primary ms-2">{t('activateAccount', { ns: 'labels' })}</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div id="deleteDiv" class="col-xl-6" >
                            <div class="card">
                                <div class="card-header">
                                    <h4 class="heading mb-0">{t('deleteUser', { ns: 'labels' })}</h4>
                                </div>
                                <div class="card-body">
                                    <div class="alert alert-warning border-warning outline-dashed py-3 px-3 mt-1 mb-4 mb-0 text-dark d-flex align-items-center">
                                        <div class="clearfix">
                                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 11.0218 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0C11.0218 0 7.20644 1.58035 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C7.20644 28.4196 11.0218 30 15 30ZM12.6562 19.6875H14.0625V15.9375H12.6562C11.877 15.9375 11.25 15.3105 11.25 14.5312C11.25 13.752 11.877 13.125 12.6562 13.125H15.4688C16.248 13.125 16.875 13.752 16.875 14.5312V19.6875H17.3438C18.123 19.6875 18.75 20.3145 18.75 21.0938C18.75 21.873 18.123 22.5 17.3438 22.5H12.6562C11.877 22.5 11.25 21.873 11.25 21.0938C11.25 20.3145 11.877 19.6875 12.6562 19.6875ZM15 7.5C15.4973 7.5 15.9742 7.69754 16.3258 8.04918C16.6775 8.40081 16.875 8.87772 16.875 9.375C16.875 9.87228 16.6775 10.3492 16.3258 10.7008C15.9742 11.0525 15.4973 11.25 15 11.25C14.5027 11.25 14.0258 11.0525 13.6742 10.7008C13.3225 10.3492 13.125 9.87228 13.125 9.375C13.125 8.87772 13.3225 8.40081 13.6742 8.04918C14.0258 7.69754 14.5027 7.5 15 7.5Z" fill="#FF8A11"></path>
                                            </svg>
                                        </div>
                                        <div class="mx-3">
                                            <h6 class="mb-0 fw-semibold">{t('deletingUserMessage', { ns: 'labels' })}</h6>
                                            <p class="mb-0">{t('deletingUserIrreversibleAction', { ns: 'labels' })}</p>
                                        </div>
                                    </div>
                                    <div class="text-end">
                                        <button onClick={() => {
                                            openDeleteModal();
                                        }} class="btn btn-danger ms-2">{t('deleteUser', { ns: 'labels' })}</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </>
            )
            //#endregion
        }
        else if (data?.group) {
            //#region group
            return (<>
                <div class="row">
                    <div id="divBasicInfo" class="col-xl-6">
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h6 class="card-title">{t('basicInfo', { ns: 'labels' })}</h6>
                                    </div>
                                    <div class="card-body">

                                        <div id="divEditAvatar" class="row mb-4">
                                            <div class="col-md-3">
                                                <label class="form-label mb-md-0">Avatar</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="d-inline-block position-relative me-4 mb-3 mb-lg-0">
                                                    <img src="images/avatar/pic7.jpg" alt="" class="rounded-4 profile-avatar" />
                                                    <button type="button" class="btn btn-primary btn-sharp position-absolute bottom-0 end-0">
                                                        <i class="fa-solid fa-pen-to-square"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row align-items-center mb-4">
                                            <div class="col-md-3">
                                                <label id="fullNameLabel" class="form-label mb-md-0">{t('name', { ns: 'labels' })}</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <input id="settings-name" type="text" class="form-control" placeholder={t('namePlaceholder', { ns: 'labels' })} value={data?.group?.Name}
                                                            onChange={(e) => {
                                                                data.group.Name = e.target.value;
                                                                setData({ group: data.group });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row align-items-center mb-3">
                                            <div class="col-md-3">
                                                <label class="form-label mb-md-0">{t('active', { ns: 'labels' })}</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" id="settings-activeUser" disabled />
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            {/* Sezione Permessi per Gruppi */}
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h6 class="card-title">{t('groupPermissions', { ns: 'labels' })}</h6>
                                    </div>
                                    <div class="card-body">
                                        {_drawPermissionsListReadOnly()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="groupsEditor" class="col-xl-6" style={{ height: "100%" }}>
                        <div class="row">

                            <div class="col-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="mb-4">
                                            <h4 class="card-title">{t('yourGroups', { ns: 'labels' })}</h4>
                                            <p>{t('addRemoveGroupGroups', { ns: 'labels' })}</p>
                                        </div>

                                        {/* Dropdown per selezionare gruppi */}
                                        <div class="mb-3">
                                            <label class="form-label">{t('selectGroupToManage', { ns: 'labels' })}</label>
                                            <div class="d-flex gap-2">
                                                <select
                                                    class="form-select"
                                                    value=""
                                                    onChange={(e) => {
                                                        if (e.target.value) {
                                                            handleAddGroupToGroup(e.target.value);
                                                            e.target.value = ""; // Reset selection
                                                        }
                                                    }}
                                                >
                                                    <option value="">{t('selectGroupToManage', { ns: 'labels' })}</option>
                                                    {groupsVoc && groupsVoc
                                                        .filter(group => !linkedGroupsDb.some(lg => lg.Back_End_Member_Of_Group_Id === group.Id))
                                                        .map(group => (
                                                            <option key={group.Id} value={group.Id}>
                                                                {group.Name}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>
                                        </div>

                                        {/* Lista gruppi selezionati */}
                                        <div class="mb-3">
                                            <label class="form-label">{t('assignedGroups', { ns: 'labels' })}</label>
                                            {linkedGroupsDb && linkedGroupsDb.length > 0 ? (
                                                <div class="list-group">
                                                    {linkedGroupsDb.map(lg => {
                                                        const group = groupsVoc?.find(g => g.Id === lg.Back_End_Member_Of_Group_Id);
                                                        return group ? (
                                                            <div key={lg.Back_End_Member_Of_Group_Id} class="list-group-item d-flex justify-content-between align-items-center">
                                                                <div class="d-flex align-items-center">
                                                                    <i class="fas fa-users text-primary me-3"></i>
                                                                    <span class="fw-semibold">{group.Name}</span>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-sm btn-outline-danger"
                                                                    onClick={() => handleRemoveGroupFromGroup(lg.Back_End_Member_Of_Group_Id)}
                                                                    title={t('remove', { ns: 'labels' })}
                                                                >
                                                                    <i class="fas fa-times"></i>
                                                                </button>
                                                            </div>
                                                        ) : null;
                                                    })}
                                                </div>
                                            ) : (
                                                <div class="alert alert-info">
                                                    <p class="mb-0">{t('noGroupsAssigned', { ns: 'labels' })}</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div class="col-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="mb-4">
                                            <h4 class="card-title">{t('members', { ns: 'labels' })}</h4>
                                            <p>{t('addRemoveMembers', { ns: 'labels' })}</p>
                                        </div>

                                        {/* Search input per selezionare membri */}
                                        <div class="mb-3">
                                            <label class="form-label">{t('selectMemberToManage', { ns: 'labels' })}</label>
                                            <div class="position-relative member-search-container">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    value={memberSearchTerm}
                                                    onChange={(e) => handleMemberSearchChange(e.target.value)}
                                                    placeholder={t('searchMemberPlaceholder', { ns: 'labels' })}
                                                    onFocus={() => {
                                                        if (memberSearchResults.length > 0) {
                                                            setShowMemberSearchResults(true);
                                                        }
                                                    }}
                                                />
                                                
                                                {/* Loading indicator */}
                                                {isSearchingMembers && (
                                                    <div class="position-absolute end-0 top-50 translate-middle-y me-3">
                                                        <div class="spinner-border spinner-border-sm text-primary" role="status">
                                                            <span class="visually-hidden">{t('searching', { ns: 'labels' })}</span>
                                                        </div>
                                                    </div>
                                                )}
                                                
                                                {/* Search results dropdown */}
                                                {showMemberSearchResults && (
                                                    <div class="position-absolute w-100 bg-white border rounded-3 shadow-lg mt-1" style={{ zIndex: 1050, maxHeight: '300px', overflowY: 'auto' }}>
                                                        {memberSearchResults.length > 0 ? (
                                                            memberSearchResults.map(user => (
                                                                <div
                                                                    key={user.Id}
                                                                    class="p-2 border-bottom hover-bg-light cursor-pointer d-flex align-items-center"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => handleSelectMemberFromSearch(user.Id)}
                                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                                >
                                                                    <i class="fas fa-user text-primary me-2"></i>
                                                                    <span>{`${user.Name} ${user.LastName}`}</span>
                                                                    {user.Email && (
                                                                        <small class="text-muted ms-2">({user.Email})</small>
                                                                    )}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div class="p-3 text-center text-muted">
                                                                {t('noMembersFound', { ns: 'labels' })}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Lista membri selezionati */}
                                        <div class="mb-3">
                                            <label class="form-label">{t('assignedMembers', { ns: 'labels' })}</label>
                                            {linkedMembersDB && linkedMembersDB.length > 0 ? (
                                                <div class="list-group">
                                                    {linkedMembersDB.map(lm => {
                                                        // Since we don't have all users preloaded, we'll use the linked member data
                                                        return (
                                                            <div key={lm.Back_End_User_Id} class="list-group-item d-flex justify-content-between align-items-center">
                                                                <div class="d-flex align-items-center">
                                                                    <i class="fas fa-user text-primary me-3"></i>
                                                                    <span class="fw-semibold">
                                                                        {lm.User_Name && lm.User_LastName 
                                                                            ? `${lm.User_Name} ${lm.User_LastName}`
                                                                            : `User ID: ${lm.Back_End_User_Id}`}
                                                                    </span>
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-sm btn-outline-danger"
                                                                    onClick={() => handleRemoveMemberFromGroup(lm.Back_End_User_Id)}
                                                                    title={t('remove', { ns: 'labels' })}
                                                                >
                                                                    <i class="fas fa-times"></i>
                                                                </button>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <div class="alert alert-info">
                                                    <p class="mb-0">{t('noMembersForThisGroup', { ns: 'labels' })}</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div id="deactivateDiv" class="col-xl-6" >
                        <div class="card">
                            <div class="card-header">
                                <h4 class="heading mb-0">{t('deactivateGroup', { ns: 'labels' })}</h4>
                            </div>
                            <div class="card-body">
                                <div class="alert alert-warning border-warning outline-dashed py-3 px-3 mt-1 mb-4 mb-0 text-dark d-flex align-items-center">
                                    <div class="clearfix">
                                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 11.0218 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0C11.0218 0 7.20644 1.58035 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C7.20644 28.4196 11.0218 30 15 30ZM12.6562 19.6875H14.0625V15.9375H12.6562C11.877 15.9375 11.25 15.3105 11.25 14.5312C11.25 13.752 11.877 13.125 12.6562 13.125H15.4688C16.248 13.125 16.875 13.752 16.875 14.5312V19.6875H17.3438C18.123 19.6875 18.75 20.3145 18.75 21.0938C18.75 21.873 18.123 22.5 17.3438 22.5H12.6562C11.877 22.5 11.25 21.873 11.25 21.0938C11.25 20.3145 11.877 19.6875 12.6562 19.6875ZM15 7.5C15.4973 7.5 15.9742 7.69754 16.3258 8.04918C16.6775 8.40081 16.875 8.87772 16.875 9.375C16.875 9.87228 16.6775 10.3492 16.3258 10.7008C15.9742 11.0525 15.4973 11.25 15 11.25C14.5027 11.25 14.0258 11.0525 13.6742 10.7008C13.3225 10.3492 13.125 9.87228 13.125 9.375C13.125 8.87772 13.3225 8.40081 13.6742 8.04918C14.0258 7.69754 14.5027 7.5 15 7.5Z" fill="#FF8A11"></path>
                                        </svg>
                                    </div>
                                    <div class="mx-3">
                                        <h6 class="mb-0 fw-semibold">{t('deactivatingGroupMessage', { ns: 'labels' })}
                                        </h6>
                                    </div>
                                </div>
                                <div class="text-end">
                                    <button onClick={() => {
                                        openDeactivateModal()
                                    }} class="btn btn-danger ms-2">{t('deactivateGroup', { ns: 'labels' })}</button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div id="activateDiv" class="col-xl-6" >
                        <div class="card">
                            <div class="card-header">
                                <h4 class="heading mb-0">{t('activeGroup', { ns: 'labels' })} </h4>
                            </div>
                            <div class="card-body">
                                <div class="alert alert-warning border-warning outline-dashed py-3 px-3 mt-1 mb-4 mb-0 text-dark d-flex align-items-center">
                                    <div class="clearfix">
                                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 11.0218 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0C11.0218 0 7.20644 1.58035 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C7.20644 28.4196 11.0218 30 15 30ZM12.6562 19.6875H14.0625V15.9375H12.6562C11.877 15.9375 11.25 15.3105 11.25 14.5312C11.25 13.752 11.877 13.125 12.6562 13.125H15.4688C16.248 13.125 16.875 13.752 16.875 14.5312V19.6875H17.3438C18.123 19.6875 18.75 20.3145 18.75 21.0938C18.75 21.873 18.123 22.5 17.3438 22.5H12.6562C11.877 22.5 11.25 21.873 11.25 21.0938C11.25 20.3145 11.877 19.6875 12.6562 19.6875ZM15 7.5C15.4973 7.5 15.9742 7.69754 16.3258 8.04918C16.6775 8.40081 16.875 8.87772 16.875 9.375C16.875 9.87228 16.6775 10.3492 16.3258 10.7008C15.9742 11.0525 15.4973 11.25 15 11.25C14.5027 11.25 14.0258 11.0525 13.6742 10.7008C13.3225 10.3492 13.125 9.87228 13.125 9.375C13.125 8.87772 13.3225 8.40081 13.6742 8.04918C14.0258 7.69754 14.5027 7.5 15 7.5Z" fill="#FF8A11"></path>
                                        </svg>
                                    </div>
                                    <div class="mx-3">
                                        <h6 class="mb-0 fw-semibold">
                                            {t('activatingGroupMessage', { ns: 'labels' })} </h6>
                                    </div>
                                </div>
                                <div class="text-end">
                                    <button onClick={() => {
                                        openActivateModal();
                                    }} class="btn btn-primary ms-2">{t('activeGroup', { ns: 'labels' })}</button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div id="deleteDiv" class="col-xl-6" >
                        <div class="card">
                            <div class="card-header">
                                <h4 class="heading mb-0">{t('deleteGroup', { ns: 'labels' })}</h4>
                            </div>
                            <div class="card-body">
                                <div class="alert alert-warning border-warning outline-dashed py-3 px-3 mt-1 mb-4 mb-0 text-dark d-flex align-items-center">
                                    <div class="clearfix">
                                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 11.0218 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0C11.0218 0 7.20644 1.58035 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C7.20644 28.4196 11.0218 30 15 30ZM12.6562 19.6875H14.0625V15.9375H12.6562C11.877 15.9375 11.25 15.3105 11.25 14.5312C11.25 13.752 11.877 13.125 12.6562 13.125H15.4688C16.248 13.125 16.875 13.752 16.875 14.5312V19.6875H17.3438C18.123 19.6875 18.75 20.3145 18.75 21.0938C18.75 21.873 18.123 22.5 17.3438 22.5H12.6562C11.877 22.5 11.25 21.873 11.25 21.0938C11.25 20.3145 11.877 19.6875 12.6562 19.6875ZM15 7.5C15.4973 7.5 15.9742 7.69754 16.3258 8.04918C16.6775 8.40081 16.875 8.87772 16.875 9.375C16.875 9.87228 16.6775 10.3492 16.3258 10.7008C15.9742 11.0525 15.4973 11.25 15 11.25C14.5027 11.25 14.0258 11.0525 13.6742 10.7008C13.3225 10.3492 13.125 9.87228 13.125 9.375C13.125 8.87772 13.3225 8.40081 13.6742 8.04918C14.0258 7.69754 14.5027 7.5 15 7.5Z" fill="#FF8A11"></path>
                                        </svg>
                                    </div>
                                    <div class="mx-3">
                                        <h6 class="mb-0 fw-semibold">
                                            {t('deletingGroupMessage', { ns: 'labels' })} </h6>
                                        <p class="mb-0">
                                            {t('deletingGroupIrreversibleAction', { ns: 'labels' })} </p>
                                    </div>
                                </div>
                                <div class="text-end">
                                    <button onClick={() => {
                                        openDeleteModal();
                                    }} class="btn btn-danger ms-2">{t('deleteGroup', { ns: 'labels' })}p</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </>)
            //#endregion
        }

    }

    const drawGroupsPanel = () => {

        if (data?.user) {
            //#region user
            return (<></>)

            //#endregion
        }
        else if (data?.group) {
            //#region group
            return (<></>)
            //#endregion
        }
    }

    const drawPage = () => {

        return (
            <>
                <div className="row">
                    <div class="col-xl-12 col-lg-12">
                        <div class="card">
                            {drawTopHeader()}
                        </div>
                    </div>
                </div>

                <div className='row' id="basicInfo">
                    <div class="col-xl-12">
                        <div class="tab-content" id="nav-tabContent">
                            <div class="tab-pane fade show active" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                                {drawHomePanel()}
                            </div>

                            <div class="tab-pane fade" id="nav-settings" role="tabpanel" aria-labelledby="nav-settings-tab">

                                {drawSettingsPanel()}
                            </div>

                            <div class="tab-pane fade" id="nav-groups" role="tabpanel" aria-labelledby="nav-groups-tab">
                                {drawGroupsPanel()}
                            </div>

                        </div>
                    </div>
                </div>
            </>

        )
    }

    const getFullNameForMember = (lm) => {
        var user = (membersVoc.find(x => x.Id == lm.Back_End_User_Id));

        // Safety check to prevent crashes
        if (!user) {
            console.warn(`User not found in membersVoc for ID: ${lm.Back_End_User_Id}`);
            return `User ID: ${lm.Back_End_User_Id}`;
        }

        return `${user.Name || 'Unknown'} ${user.LastName || ''}`
    }
    const _drawUsersListReadOnly = () => {
        if (data?.group || data?.user) {
            if (linkedMembersDB && linkedMembersDB.length > 0) {
                return (
                    linkedMembersDB.map((lm) =>
                    (
                        <div class="d-flex align-items-center p-2 hover-bg-light rounded my-1">
                            <div class="avatar avatar-md border border-secondary border-opacity-10 rounded d-flex align-items-center justify-content-center bg-white">
                                <img class="avatar avatar-md" src={standardPic} width={20} alt="" />
                            </div>
                            <div class="clearfix ms-3">
                                <h6 class="fs-14 mb-0 fw-semibold">{getFullNameForMember(lm)}</h6>
                            </div>
                        </div>
                    ))
                )
            }
            else return (<p>{t('noMembersForThisGroup', { ns: 'labels' })}</p>)
        } else { return (<p>{t('noMembersForThisGroup', { ns: 'labels' })}</p>) }
    }

    // Handle adding a group to the user
    const handleAddGroupToUser = (groupId) => {
        if (!groupId || !availableGroups) return;

        // Check if group is already added
        const isAlreadyAdded = linkedGroupsDb.some(lg => lg.Back_End_Member_Of_Group_Id === groupId);
        if (isAlreadyAdded) return;

        // Add new group link
        const newLink = {
            Back_End_Member_Of_Group_Id: groupId
        };

        const updatedLinks = [...linkedGroupsDb, newLink];
        setLinkedGroupsDb(updatedLinks);
    };

    // Handle removing a group from the user
    const handleRemoveGroupFromUser = (groupId) => {
        const updatedLinks = linkedGroupsDb.filter(lg => lg.Back_End_Member_Of_Group_Id !== groupId);
        setLinkedGroupsDb(updatedLinks);
    };

    // Handle adding a group to a group
    const handleAddGroupToGroup = (groupId) => {
        if (!groupId || !groupsVoc) return;

        // Check if group is already added
        const isAlreadyAdded = linkedGroupsDb.some(lg => lg.Back_End_Member_Of_Group_Id === groupId);
        if (isAlreadyAdded) return;

        // Add new group link
        const newLink = {
            Back_End_Member_Of_Group_Id: groupId
        };

        const updatedLinks = [...linkedGroupsDb, newLink];
        setLinkedGroupsDb(updatedLinks);
    };

    // Handle removing a group from a group
    const handleRemoveGroupFromGroup = (groupId) => {
        const updatedLinks = linkedGroupsDb.filter(lg => lg.Back_End_Member_Of_Group_Id !== groupId);
        setLinkedGroupsDb(updatedLinks);
    };

    // Handle adding a member to a group
    const handleAddMemberToGroup = (memberId) => {
        if (!memberId) return;

        // Check if member is already added
        const isAlreadyAdded = linkedMembersDB.some(lm => lm.Back_End_User_Id === memberId);
        if (isAlreadyAdded) return;

        // Find the user in search results to get full user data
        const selectedUser = memberSearchResults.find(user => user.Id === memberId);
        
        if (selectedUser) {
            // Add user to membersVoc if not already present
            const isUserInVoc = membersVoc.some(user => user.Id === memberId);
            if (!isUserInVoc) {
                setMembersVoc([...membersVoc, selectedUser]);
            }
        }

        // Add new member link with user data for display
        const newLink = {
            Back_End_User_Id: memberId,
            Back_End_Member_Of_Group_Id: id,
            // Include user name data if available from search results
            User_Name: selectedUser?.Name || null,
            User_LastName: selectedUser?.LastName || null
        };

        const updatedLinks = [...linkedMembersDB, newLink];
        setLinkedMembersDB(updatedLinks);
    };

    // Handle removing a member from a group
    const handleRemoveMemberFromGroup = (memberId) => {
        const updatedLinks = linkedMembersDB.filter(lm => lm.Back_End_User_Id !== memberId);
        setLinkedMembersDB(updatedLinks);
    };

    const _drawPermissionsListReadOnly = () => {
        return (
            <>
                {/* Dropdown per selezionare nodo diritti */}
                <div class="mb-3">
                    <label class="form-label">{t('selectRightsNode', { ns: 'labels' })}</label>
                    <div class="d-flex gap-2">
                        <div style={{ flexGrow: 1 }}>
                            <Choices
                                voc={rightsTree}
                                value="Code"
                                text="Name"
                                className="inputStyle blackText bg-white"
                                selected={selectedRightsNode ? [{ Code: selectedRightsNode }] : []}
                                onChange={(e) => {
                                    const selected = e.selected?.[0]?.Code || "";
                                    if (selected) {
                                        const selectedNodeData = rightsTree.find(node => node.Code === selected);
                                        if (selectedNodeData?.OriginalNode) {
                                            // Check if rights node already exists
                                            const exists = userRightsPermissions.some(p => p.RightsTreeId === selectedNodeData.OriginalNode.Id);
                                            if (exists) {
                                                userPopUpAction('Nodo diritti già assegnato');
                                                return;
                                            }

                                            const newPermission = {
                                                Id: crypto.randomUUID ? crypto.randomUUID() : 'temp-' + Date.now(),
                                                RightsTreeId: selectedNodeData.OriginalNode.Id,
                                                RightsNodeName: selectedNodeData.OriginalNode.Name,
                                                RightsNodeDescription: selectedNodeData.OriginalNode.Description,
                                                Read: false,
                                                Write: false,
                                                List: false,
                                                Delete: false,
                                                TakeOwnership: false,
                                                UserId: type === "user" ? id : null,
                                                GroupId: type === "group" ? id : null
                                            };

                                            setUserRightsPermissions([...userRightsPermissions, newPermission]);
                                        }
                                    }
                                    // Reset selection
                                    setSelectedRightsNode("");
                                    setSelectedRightsNodeObject(null);
                                }}
                                placeholder={t('selectRightsNode', { ns: 'labels' })}
                                dropDownParent="root"
                            />
                        </div>
                    </div>
                </div>

                {/* Lista nodi diritti assegnati */}
                <div class="mb-3">
                    {userRightsPermissions && userRightsPermissions.length > 0 ? (
                        <div class="list-group">
                            {userRightsPermissions.map(permission => (
                                <div key={permission.RightsTreeId} class="list-group-item">
                                    <div class="d-flex justify-content-between align-items-start mb-2">
                                        <div>
                                            <strong>{permission.RightsNodeName}</strong>
                                            {permission.RightsNodeDescription && (
                                                <span class="text-muted small ms-2">- {permission.RightsNodeDescription}</span>
                                            )}
                                        </div>
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-danger"
                                            onClick={() => handleRemoveRightsNodePermission(permission.RightsTreeId)}
                                            title={t('remove', { ns: 'labels' })}
                                        >
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>

                                    {/* Permessi checkbox */}
                                    <div class="d-flex gap-3 flex-wrap">
                                        <div class="form-check">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                id={`read-${permission.RightsTreeId}`}
                                                checked={permission.Read || false}
                                                onChange={(e) => handleUpdateRightsNodePermission(permission.RightsTreeId, 'Read', e.target.checked)}
                                            />
                                            <label class="form-check-label" htmlFor={`read-${permission.RightsTreeId}`}>
                                                {t('read', { ns: 'labels' })}
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                id={`write-${permission.RightsTreeId}`}
                                                checked={permission.Write || false}
                                                onChange={(e) => handleUpdateRightsNodePermission(permission.RightsTreeId, 'Write', e.target.checked)}
                                            />
                                            <label class="form-check-label" htmlFor={`write-${permission.RightsTreeId}`}>
                                                {t('write', { ns: 'labels' })}
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                id={`list-${permission.RightsTreeId}`}
                                                checked={permission.List || false}
                                                onChange={(e) => handleUpdateRightsNodePermission(permission.RightsTreeId, 'List', e.target.checked)}
                                            />
                                            <label class="form-check-label" htmlFor={`list-${permission.RightsTreeId}`}>
                                                {t('list', { ns: 'labels' })}
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                id={`delete-${permission.RightsTreeId}`}
                                                checked={permission.Delete || false}
                                                onChange={(e) => handleUpdateRightsNodePermission(permission.RightsTreeId, 'Delete', e.target.checked)}
                                            />
                                            <label class="form-check-label" htmlFor={`delete-${permission.RightsTreeId}`}>
                                                {t('delete', { ns: 'labels' })}
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                id={`takeOwnership-${permission.RightsTreeId}`}
                                                checked={permission.TakeOwnership || false}
                                                onChange={(e) => handleUpdateRightsNodePermission(permission.RightsTreeId, 'TakeOwnership', e.target.checked)}
                                            />
                                            <label class="form-check-label" htmlFor={`takeOwnership-${permission.RightsTreeId}`}>
                                                {t('takeOwnership', { ns: 'labels' })}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            ))}


                        </div>
                    ) : (
                        <div class="alert alert-info">
                            <p class="mb-0">{t('noRightsAssigned', { ns: 'labels' })}</p>
                        </div>
                    )}
                </div>
            </>
        );
    };

    const _drawGroupListReadOnly = () => {
        if (data?.group || data?.user) {

            if (linkedGroupsDb && linkedGroupsDb.length > 0) {
                // Use availableGroups for users, groupsVoc for groups
                const groupSource = data?.user ? availableGroups : groupsVoc;

                if (!groupSource || groupSource.length === 0) {
                    return (<p> {t('noLinkWithGroups', { ns: 'labels' })}  </p>);
                }

                return (
                    linkedGroupsDb.map((lg) => {
                        const group = groupSource.find(x => x.Id == lg.Back_End_Member_Of_Group_Id);
                        if (!group) return null;

                        return (
                            <div key={lg.Back_End_Member_Of_Group_Id} class="d-flex align-items-center p-2 hover-bg-light rounded my-1">
                                <i class="fas fa-users text-primary me-3 fs-5"></i>
                                <div class="clearfix">
                                    <h6 class="fs-14 mb-0 fw-semibold">{group.Name}</h6>
                                </div>
                            </div>
                        )
                    }).filter(item => item !== null)
                )

            }
            else return (<p> {t('noLinkWithGroups', { ns: 'labels' })}  </p>)
        } else { return (<p>{t('noLinkWithGroups', { ns: 'labels' })} </p>) }

    }


    return (
        <div className="d-flex flex-column" style={{ height: '100vh' }}>
            {/* HEADER + TOOLBAR (fixed, never scrolls) */}
            <header className="bg-white shadow-sm" style={{ position: 'sticky', top: 0, zIndex: 1000 }}>
                <div className="container-fluid d-flex justify-content-between align-items-center py-2 fixed-toolbar">
                    {/* breadcrumb navigation */}
                    <ol className="breadcrumb mb-0">

                    </ol>
                    
                    {/* action buttons */}
                    <div className="d-flex gap-3">
                        <a className="text-primary fs-13" onClick={(e) => {
                            if (data?.group) {
                                saveGroupData();
                            }
                            else if (data?.user) {
                                saveUserData();
                            }

                        }} role="button" aria-controls="offcanvasExample1" title="Save this data"><i className="fa-solid fa-floppy-disk fa-2x"></i></a>
                    </div>
                </div>
            </header>

            {/* SCROLLABLE CONTENT AREA */}
            <main className="flex-grow-1 overflow-auto">
                <div className="container-fluid">
                    {(data?.user || data?.group) ? drawPage() : <Loader />}
                    {createDeactiveteModal()}
                    {createActiveteModal()}
                    {createDeleteModal()}
                </div>
            </main>
        </div>
    )
}

export { Users_Profile_Screen }